<template>
  <div class="home">
    <img class="ruleimg" src="@/assets/img2/home-rule.png" @click="rulePopupShow = true" />
    <img class="ruleimg shareimg" src="@/assets/img2/home-share.png" @click="sharePopupShow = true" />

    <img class="toplogo" src="@/assets/img2/logo-white.png" />
    <img class="toptitle" src="@/assets/img2/home-toptitle.png" />
    <div class="time">
      <img class="icon" src="@/assets/img2/home-iconL.png" />
      <div>活动时间：2026年5月18日-6月30日</div>
      <img class="icon" src="@/assets/img2/home-iconR.png" />
    </div>

    <diV class="fhcbox">
      <img class="map" src="@/assets/img2/home-map.png" />
      <img class="fhc1" src="@/assets/img2/home-fhc1.png" @click="gofhc('venueone')" />
      <img class="fhc2" src="@/assets/img2/home-fhc2.png" @click="gofhc('venuetwo')" />
      <img class="fhc3" src="@/assets/img2/home-fhc2.png" @click="gofhc('venuethree')" />
    </diV>



    <!-- 关注公众号 -->
    <van-popup v-model="gzhPopupShow" position="center" :close-on-click-overlay="false" class="custom-popup-gzh">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title3.png" alt="">
        <img class="logo" src="@/assets/img2/logo.png" alt="">
        <img class="ewm" :src="gzhImg" alt="">
        <div class="des">（长按关注紫金保险官方公众号参与活动）</div>
      </div>
    </van-popup>

    <!-- 活动规则 -->
    <van-popup v-model="rulePopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-gzh custom-popup-rule">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title2.png" alt="">
        <div class="textbox">
          <div class="text">
            1.紫金保险会员每日登录可获得1次免费开福袋机会；
          </div>
          <div class="text">
            2.点击福袋，福袋打开，弹出对应奖品；
          </div>
          <div class="text">
            3.连续签到奖励：连续签到 3 天、7 天可额外获得 1 次开福袋机会;
          </div>
          <div class="text">
            4.分享奖励：分享活动给好友，好友参与后分享者额外获得 1 次机会
          </div>
        </div>
        <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="rulePopupShow = false">
      </div>
    </van-popup>

    <!-- 分享 -->
    <van-popup v-model="sharePopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-gzh custom-popup-share">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title1.png" alt="">
        <div class="textbox">
          <div class="text">
            1.点击右上角【…】图标
          </div>
          <img class="shareexample" src="@/assets/img2/home-share-example.png" alt="">
          <div class="text">
            2.点击“转发给朋友”按钮即可将活动分享给好友
          </div>
          <div class="text">
            3.好友参与后即可额外获得 1 次机会开福袋机会，可返回小程序查看
          </div>
        </div>
        <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="sharePopupShow = false">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPageLlq } from '@/utils/index.js'
import wx from "weixin-js-sdk"
import { loginApi, getActApi, getPersonApi, trackingMonitor, postConfigApi, shareApi } from '@/api/index.js'
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      pageType: null,

      gzhPopupShow: false,
      rulePopupShow: false,
      sharePopupShow: false,

      gzhImg: require('@/assets/img2/' + process.env.VUE_APP_ZKING_GZHIMG + '.png'),
    }
  },
  created() {
    console.log('首页页面参数',this.$route.query);
    
    this.pageType = getPageLlq()

    if (this.$route.query.return_zking_info) {
      loginApi({ utoken: this.$route.query.return_zking_info }).then((res) => {
        localStorage.setItem('Authorization', res.data.accessToken)
        this.getPersonData()
      });
    } else {
      this.getPersonData()
    }
  },

  methods: {
    getPersonData() {
      getPersonApi().then((res) => {
        if (res.code == 1006000000) {
          this.gzhPopupShow = true
        } else {
          this.gzhPopupShow = false
        }
      });
    },



    gowxlogin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            console.log("在小程序里");
            wx.miniProgram.navigateTo({
              url: '/pages/login/login',
              success: (res) => { console.log('成功') },
              fail: (res) => { console.log('失败') },
              complete: (res) => { console.log('完成') },
            })
          } else {
            console.log("不在小程序里");
            window.location.href = process.env.VUE_APP_ZKING_BASE_API + '/app/sso-passport-authenticate/wecom/activityWxCode.html?wServerName=GW_KHJ2024&returnUrl=' + process.env.VUE_APP_ZKING_INDEX_PAGE
          }
        })
      } else {
        console.log('不在微信里');
        window.location.href = process.env.VUE_APP_ZKING_BASE_API + '/app/sso-passport-authenticate/wecom/activityWxCode.html?wServerName=GW_KHJ2024&returnUrl=' + process.env.VUE_APP_ZKING_INDEX_PAGE
      }
    },



    // 跳转分会场
    gofhc(path) {
      this.$router.push({ path: path })
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  background: linear-gradient(180deg, #9C4AFF 0%, #B675F8 46.44%, #ECCAFA 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;

  .toplogo {
    width: 115px;
    height: 22px;
    position: absolute;
    left: 10px;
    top: 10px;
  }

  .toptitle {
    width: 298px;
    height: 158px;
    margin-top: 40px;
  }

  .time {
    font-weight: 600;
    font-size: 13px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0 20px 0;

    .icon {
      width: 40px;
      height: 16px;
      margin: 0 8px;
    }
  }


  .fhcbox {
    position: relative;

    .map {
      width: 370px;
      margin: 0 auto;
      margin-top: 25px;
    }

    .fhc1 {
      width: 188px;
      height: 200px;
      position: absolute;
      top: 0;
      left: 10px;
    }

    .fhc2 {
      width: 188px;
      height: 185px;
      position: absolute;
      top: 190px;
      right: 10px;
    }

    .fhc3 {
      width: 188px;
      height: 188px;
      position: absolute;
      bottom: 90px;
      left: 20px;
    }
  }

  .ruleimg {
    width: 46px;
    height: 46px;
    position: absolute;
    top: 250px;
    right: 12px;
    z-index: 9;
  }

  .shareimg {
    top: 310px;
  }
}
</style>
